import React from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as BlockedDocumentsIcon } from "./../../../../assets/icons/no_locker.svg";
import { useNavigate } from "react-router-dom";

const NoLockerAvailable = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleContactSupport = () => {
    navigate("/hints/page/HelpAccordionList");
  };

  return (
    <div className="flex flex-col w-full h-full">
      {/* Main content - centered */}
      <div className="flex flex-col items-center justify-center flex-1">
        {/* <CiCircleCheck className="size-[135px] text-primary" /> */}
        <BlockedDocumentsIcon
          width={120}
          height={120}
          className="text-primary"
        />

        <div className="max-w-md mx-auto mb-5 mt-6 text-center p-4">
          <p className="text-foreground text-base leading-relaxed mb-5">
            {t("book_location.parcel_placement.unavailable_locker.description")}{" "}
            <span
              className="text-primary cursor-pointer"
              onClick={handleContactSupport}
            >
              {t("book_location.success.contact_support", "Contact support")}
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default NoLockerAvailable;
